import Title from "@/components/atoms/Title";
import Interpreter from "@/components/organisms/Interpreter";
import Footer from "@/components/templates/Footer";
import NavBar from "@/components/templates/NavBar";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import React from "react";
import Newsletter from "@/components/templates/Newsletter";
import { addConditionalNoIndexTag } from "@/utils/helpers";

const Page = (props) => {
  const { noIndex } = props;
  const { t } = useTranslation("common", "terms");
  const content = t("terms:terms", { returnObjects: true });
  addConditionalNoIndexTag();
  
  return (
    <>
      <Head>
      <title>{t("terms:metas.title" || "")}</title>
        <meta name="description" content={t("terms:metas.description" || "")} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        {noIndex && <meta name="robots" content="noindex" />}
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href={t('common:canonical_pages.terms-conditions')} />
      </Head>
      <main>
        <NavBar className="navbar-blue" />
        <Title className="pt-40 hero-title pb-10">{t("terms:title")}</Title>
        <div className="base-container base-grid mb-20">
          <div className="col-span-12 md:col-start-2 md:col-span-10">
            <Interpreter content={content} />
          </div>
        </div>
        <Newsletter/>
        <Footer />
      </main>
    </>
  );
};

export async function getServerSideProps({ locale }) {
  const noIndex = process.env.ENV_NO_INDEX || false;
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "terms", "routes"])),

      noIndex,
    },
  };
}

export default Page;
